/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { StatusBadge, type StatusBadgeConfig } from '@g17eco/molecules/badge/StatusBadge';
import type { Priority } from '@g17eco/types/insights-synthesis';

interface ImpactBadgeProps {
  impact: Priority;
  showLabel?: boolean;
}

const impactConfig: Record<Priority, StatusBadgeConfig> = {
  low: { color: 'secondary', icon: '', label: 'Low' },
  medium: { color: 'info', icon: '', label: 'Medium' },
  high: { color: 'warning', icon: '', label: 'High' },
  critical: { color: 'danger', icon: '', label: 'Critical' },
};

export const ImpactBadge = ({ impact, showLabel = false }: ImpactBadgeProps) => {
  const config = impactConfig[impact];
  const displayConfig = showLabel ? { ...config, label: `${config.label} Impact` } : config;

  return <StatusBadge config={displayConfig} minWidth={60} />;
};
